// Qualifications for child care (babysitter and nanny)
export type ChildCareQualification =
  | 'FIRST_AID_TRAINING'
  | 'CPR_CERTIFIED'
  | 'REGISTERED_NURSE'
  | 'CERTIFIED_NURSING_ASSISTANT'
  | 'LICENSED_PRACTICAL_NURSE'
  | 'LICENSED_VOCATIONAL_NURSE'
  | 'OCCUPATIONAL_THERAPIST'
  | 'PHYSICAL_THERAPIST'
  | 'SPEECH_THERAPIST'
  | 'EARLY_CHILDHOOD_SPECIAL_EDUCATION_CERTIFICATION'
  | 'SPECIAL_EDUCATION_CERTIFICATION'
  | 'EXPERIENCE_DOULA';

// Qualifications for companionCare
export type CompanionCareQualification =
  | 'BONDED'
  | 'LICENSED'
  | 'INSURED'
  | 'FIRST_AID_TRAINING'
  | 'CPR_CERTIFIED'
  | 'REGISTERED_NURSE'
  | 'CERTIFIED_NURSING_ASSISTANT'
  | 'LICENSED_PRACTICAL_NURSE'
  | 'LICENSED_VOCATIONAL_NURSE'
  | 'OCCUPATIONAL_THERAPIST'
  | 'PHYSICAL_THERAPIST'
  | 'SPEECH_THERAPIST';

// All possible languages
export type Language =
  | 'ARABIC'
  | 'ARMENIAN'
  | 'BENGALI'
  | 'BULGARIAN'
  | 'BURMESE'
  | 'CHINESE'
  | 'CREOLE'
  | 'CZECH'
  | 'DANISH'
  | 'DUTCH'
  | 'ENGLISH'
  | 'ERITRIAN'
  | 'ESPERANTO'
  | 'ESTONIAN'
  | 'FANTI'
  | 'FARSI'
  | 'FINNISH'
  | 'FRENCH'
  | 'GERMAN'
  | 'GREEK'
  | 'HAUSA'
  | 'HAWAIIAN'
  | 'HEBREW'
  | 'HINDI'
  | 'HUNGARIAN'
  | 'IGBO'
  | 'IRISH'
  | 'ITALIAN'
  | 'JAPANESE'
  | 'KOREAN'
  | 'MANDARIN'
  | 'NORWEGIAN'
  | 'OTHER'
  | 'POLISH'
  | 'PORTUGUESE'
  | 'PUNJABI'
  | 'RUSSIAN'
  | 'SIGN_LANGUAGE'
  | 'SINGALESE'
  | 'SPANISH'
  | 'SWAHILI'
  | 'SWEDISH'
  | 'TEMME'
  | 'THAI'
  | 'TURKISH'
  | 'TWI'
  | 'UKRAINIAN'
  | 'URDU'
  | 'WELSH'
  | 'YIDDISH'
  | 'CHINESE_CANTONESE'
  | 'CHINESE_MANDARIN'
  | 'CHINESE_OTHER_DIALECTS'
  | 'HAITIAN_CREOLE'
  | 'FANTE'
  | 'AMERICAN_SIGN_LANGUAGE'
  | 'SINHALA'
  | 'TEME'
  | 'TIGRE'
  | 'TIGRINYA';

export const childCareQualificationMap: Record<ChildCareQualification, { text: string }> = {
  FIRST_AID_TRAINING: { text: 'First aid training' },
  CPR_CERTIFIED: { text: 'CPR certified' },
  REGISTERED_NURSE: { text: 'Registered nurse' },
  CERTIFIED_NURSING_ASSISTANT: { text: 'Certified nursing assistant' },
  LICENSED_PRACTICAL_NURSE: { text: 'Licensed practical nurse' },
  LICENSED_VOCATIONAL_NURSE: { text: 'Licensed vocational nurse' },
  OCCUPATIONAL_THERAPIST: { text: 'Occupational therapist' },
  PHYSICAL_THERAPIST: { text: 'Physical therapist' },
  SPEECH_THERAPIST: { text: 'Speech therapist' },
  EARLY_CHILDHOOD_SPECIAL_EDUCATION_CERTIFICATION: { text: 'Early childhood special education certification' },
  SPECIAL_EDUCATION_CERTIFICATION: { text: 'Special education certification' },
  EXPERIENCE_DOULA: { text: 'Experience as doula' },
};

export const companionCareQualificationMap: Record<CompanionCareQualification, { text: string }> = {
  BONDED: { text: 'Bonded' },
  LICENSED: { text: 'Licensed' },
  INSURED: { text: 'Insured' },
  FIRST_AID_TRAINING: { text: 'First aid training' },
  CPR_CERTIFIED: { text: 'CPR certified' },
  REGISTERED_NURSE: { text: 'Registered nurse' },
  CERTIFIED_NURSING_ASSISTANT: { text: 'Certified nursing assistant' },
  LICENSED_PRACTICAL_NURSE: { text: 'Licensed practical nurse' },
  LICENSED_VOCATIONAL_NURSE: { text: 'Licensed vocational nurse' },
  OCCUPATIONAL_THERAPIST: { text: 'Occupational therapist' },
  PHYSICAL_THERAPIST: { text: 'Physical therapist' },
  SPEECH_THERAPIST: { text: 'Speech therapist' },
};

export const languageMap: Record<Language, { text: string }> = {
  ARABIC: { text: 'Arabic' },
  ARMENIAN: { text: 'Armenian' },
  BENGALI: { text: 'Bengali' },
  BULGARIAN: { text: 'Bulgarian' },
  BURMESE: { text: 'Burmese' },
  CHINESE: { text: 'Chinese' },
  CREOLE: { text: 'Creole' },
  CZECH: { text: 'Czech' },
  DANISH: { text: 'Danish' },
  DUTCH: { text: 'Dutch' },
  ENGLISH: { text: 'English' },
  ERITRIAN: { text: 'Eritrian' },
  ESPERANTO: { text: 'Esperanto' },
  ESTONIAN: { text: 'Estonian' },
  FANTI: { text: 'Fanti' },
  FARSI: { text: 'Farsi' },
  FINNISH: { text: 'Finnish' },
  FRENCH: { text: 'French' },
  GERMAN: { text: 'German' },
  GREEK: { text: 'Greek' },
  HAUSA: { text: 'Hausa' },
  HAWAIIAN: { text: 'Hawaiian' },
  HEBREW: { text: 'Hebrew' },
  HINDI: { text: 'Hindi' },
  HUNGARIAN: { text: 'Hungarian' },
  IGBO: { text: 'Igbo' },
  IRISH: { text: 'Irish' },
  ITALIAN: { text: 'Italian' },
  JAPANESE: { text: 'Japanese' },
  KOREAN: { text: 'Korean' },
  MANDARIN: { text: 'Mandarin' },
  NORWEGIAN: { text: 'Norwegian' },
  OTHER: { text: 'Other' },
  POLISH: { text: 'Polish' },
  PORTUGUESE: { text: 'Portuguese' },
  PUNJABI: { text: 'Punjabi' },
  RUSSIAN: { text: 'Russian' },
  SIGN_LANGUAGE: { text: 'Sign language' },
  SINGALESE: { text: 'Singalese' },
  SPANISH: { text: 'Spanish' },
  SWAHILI: { text: 'Swahili' },
  SWEDISH: { text: 'Swedish' },
  TEMME: { text: 'Temme' },
  THAI: { text: 'Thai' },
  TURKISH: { text: 'Turkish' },
  TWI: { text: 'Twi' },
  UKRAINIAN: { text: 'Ukrainian' },
  URDU: { text: 'Urdu' },
  WELSH: { text: 'Welsh' },
  YIDDISH: { text: 'Yiddish' },
  CHINESE_CANTONESE: { text: 'Chinese (Cantonese)' },
  CHINESE_MANDARIN: { text: 'Chinese (Mandarin)' },
  CHINESE_OTHER_DIALECTS: { text: 'Chinese (Other dialects)' },
  HAITIAN_CREOLE: { text: 'Haitian Creole' },
  FANTE: { text: 'Fante' },
  AMERICAN_SIGN_LANGUAGE: { text: 'American Sign Language' },
  SINHALA: { text: 'Sinhala' },
  TEME: { text: 'Teme' },
  TIGRE: { text: 'Tigre' },
  TIGRINYA: { text: 'Tigrinya' },
};

export const getSkills = (profileData: Record<string, any>, careType: string): Record<string, any> => {
  switch (careType) {
    case 'babysitter':
    case 'nanny':
      return {
        qualifications: profileData.qualifications || [],
        childCareQualifications: profileData.childCareQualifications || [],
        languagesSpoken: profileData.languagesSpoken || [],
      };
    case 'companionCare':
      return {
        qualifications: profileData.qualifications || [],
        languagesSpoken: profileData.languagesSpoken || [],
      };
    default:
      return {
        languagesSpoken: profileData.languagesSpoken || [],
      };
  }
};

export const hasSkills = (profileData: Record<string, any>, careType: string): boolean => {
  const skills = getSkills(profileData, careType);
  return Object.values(skills).some((value) => Array.isArray(value) && value.length > 0);
};
